import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { Box, Button, Divider, Paper } from '@mui/material';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { AxiosError } from 'axios';
import { EmptyPage } from '../../commonComponent/table/EmptyPage';
import { debouncehook } from '../../../hooks/debouncehook';
import { UserInquireTable } from './UserInquireTable';
import { IUser } from '../../../models/user';
import { SelectSearchBox } from '../../commonComponent/SelectSearchBox';
import { xapi } from '../../../hooks/session';
import { getUserList, downloadUserList } from '../../../common/api/ApiUser';
import { KEY_USER_LIST } from '../../../common/key';
import { RESULT_OK } from '../../../common/resultCode';
import { encodeSearchWord } from '../../../common/helper';

interface Props {}

const selectVal = [
  { title: '닉네임', value: 'nickname' },
  { title: '계정', value: 'membercode' },
  {
    title: 'UID',
    value: 'uid',
  },
];

const columns = [
  {
    name: '닉네임',
    id: 'nickname',
  },
  {
    name: 'UID',
    id: 'uid',
  },
  {
    name: '이메일 계정',
    id: 'email',
  },
  {
    name: '계정 코드',
    id: 'membercode',
  },
  {
    name: '학교',
    id: 'school',
  },
  {
    name: '학급',
    id: 'class',
  },
  {
    name: '출석 번호',
    id: 'number',
  },
  {
    name: '성별',
    id: 'gender',
  },
  {
    name: '가입 일시',
    id: 'joinDate',
  },
  {
    name: '앱 버전',
    id: 'appVersion',
  },
  {
    name: '연동 앱',
    id: 'detail',
  },
];

export const UserInquire: React.FC<Props> = () => {
  const queryClient = useQueryClient();
  const emailRef = useRef<any>();
  const selectRef = useRef<any>(2);
  const searchRef = useRef<any>();
  const fileInputRef = useRef<any>();
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentRow, setCurrentRow] = useState<string>('');
  const [openEmailAdd, setOpenEmailAdd] = useState<boolean>(false);
  const [userDataforInfoDetail, setUserDataforInfoDetail] = useState<any>([]);
  const [showUserInfoDetail, setShowUserInfoDetail] = useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [uOpen, setUOpen] = useState(false);
  const uu = () => setUOpen(!uOpen);

  var searchWord = '';
  var searchKey = '';

  const {
    data,
    isLoading,
    refetch: refetchUsers,
  } = useQuery(
    KEY_USER_LIST,
    () => {
      if (searchKey !== '') {
        return getUserList(
          page,
          rowsPerPage,
          searchKey,
          encodeSearchWord(searchKey, searchWord)
        );
      }
      return null;
    },
    {
      onSuccess: res => {
        if (res !== null) {
          setList(res.userList);
          setTotalRecords(res.totalRecordCount);
        } else {
          setList([]);
        }
      },
      onError: e => {
        console.log(e);
      },
    }
  );

  const prefetchUsers = () => {
    queryClient.prefetchQuery(KEY_USER_LIST, () => {
      searchKey = selectRef.current.value;
      searchWord = searchRef.current.value;

      if (searchKey !== '') {
        return getUserList(
          page,
          rowsPerPage,
          searchKey,
          encodeSearchWord(searchKey, searchWord)
        );
      }
      return null;
    });
  };

  const isSearching = () => {
    if (selectRef.current.value) {
      searchKey = selectRef.current.value;
      searchWord = searchRef.current.value;
    } else {
      searchKey = '';
      searchWord = '';
    }

    refetchUsers();
  };

  const onDownloadFile = () => {
    if (selectRef.current.value) {
      searchKey = selectRef.current.value;
      searchWord = searchRef.current.value;
    } else {
      searchKey = '';
      searchWord = '';
    }
    downloadUserList(searchKey, encodeSearchWord(searchKey, searchWord));
  };

  return (
    <Paper>
      <Box className='' sx={{ p: '1rem' }}>
        <Box className='flex_between'>
          <SelectSearchBox
            searchOption={selectVal}
            searchWord={searchRef}
            defaultOption='nickname'
            isSearching={isSearching}
            optionValue={selectRef}
          />
          <Box className='flex_start'>
            <Button
              color='info'
              variant='outlined'
              sx={{ mr: '1rem', p: '.2rem 1rem' }}
              onClick={(evt: any) => {
                onDownloadFile();
              }}
            >
              데이터 다운로드
              <FileDownloadRoundedIcon color='success' />
            </Button>
          </Box>
        </Box>
        <Divider />
        {list.length === 0 ? (
          <EmptyPage />
        ) : (
          <UserInquireTable
            columns={columns}
            rows={list}
            totalCount={totalRecords}
            rowsPerPage={rowsPerPage}
            searchData={[selectRef.current.value, searchRef.current.value]}
            onAddEmail={() => setOpenEmailAdd(true)}
            setUserData={setUserDataforInfoDetail}
            isOpenUserDetail={() => setShowUserInfoDetail(!showUserInfoDetail)}
          />
        )}
      </Box>
    </Paper>
  );
};
